const ArrowElement = ({ color = '#000', isPointedUp }) => `
	&:after {
		content: '';
		border-style: solid;
		position: absolute;
		top: 50%;
		right: 10px;
		transform: translate(0, -50%);
		${isPointedUp ? `
			border-width: 0 4.5px 6px;
			border-color: transparent transparent ${color};
		` : `
			border-width: 6px 4.5px 0;
			border-color: ${color} transparent transparent;
		`}

	}
`

export default ArrowElement
